'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AddPromoCodePopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/AddPromoCodePopup');

var _AddPromoCodePopup2 = _interopRequireDefault(_AddPromoCodePopup);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _payments = require('redux/modules/payments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddPromoCodePopupContainer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AddPromoCodePopupContainer, _React$Component);

  function AddPromoCodePopupContainer(props) {
    (0, _classCallCheck3.default)(this, AddPromoCodePopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddPromoCodePopupContainer.__proto__ || (0, _getPrototypeOf2.default)(AddPromoCodePopupContainer)).call(this, props));

    _this.state = {
      error: ''
    };
    _this.handleApplyPromo = _this.handleApplyPromo.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AddPromoCodePopupContainer, [{
    key: 'handleApplyPromo',
    value: function handleApplyPromo(code) {
      // code = code.replace(/“|”/gi, ''); //
      this.props.applyPromocode(code);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.error !== nextProps.error) {}
    }
  }, {
    key: 'render',
    value: function render() {
      var activePromo = this.props.activePromo;

      var promoActivated = false;

      if (activePromo && activePromo.activeTill) {
        var activeTillTime = (0, _moment2.default)(activePromo.activeTill).valueOf();
        var nowTime = new Date().getTime();
        promoActivated = activeTillTime > new Date().getTime();
      }

      return _react2.default.createElement(_AddPromoCodePopup2.default, {
        icon: '/quixel_2080_logo.png',
        submitting: activePromo.applyingPromo,
        error: activePromo.error,
        message: activePromo.message,
        submittedCode: activePromo.code,
        promoActivated: promoActivated,
        onApplyPromo: this.handleApplyPromo
      });
    }
  }]);
  return AddPromoCodePopupContainer;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    activePromo: state.payments.activePromo
  };
}, { applyPromocode: _payments.applyPromocode })(AddPromoCodePopupContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddPromoCodePopupContainer/AddPromoCodePopupContainer.jsx
// module id = 2806
// module chunks = 0